// src/components/landing/images.js
//
// Telas reais do PsyAssist capturadas com dados de demonstração
// (nomes e valores fictícios). Cada imagem tem uma versão AVIF e uma WebP
// em duas larguras.

import rotinaHoje1600Avif from "../../assets/landing/rotina-hoje-1600.avif";
import rotinaHoje1600Webp from "../../assets/landing/rotina-hoje-1600.webp";
import rotinaHoje900Avif from "../../assets/landing/rotina-hoje-900.avif";
import rotinaHoje900Webp from "../../assets/landing/rotina-hoje-900.webp";

import regua1100Avif from "../../assets/landing/regua-cobranca-1100.avif";
import regua1100Webp from "../../assets/landing/regua-cobranca-1100.webp";
import regua640Avif from "../../assets/landing/regua-cobranca-640.avif";
import regua640Webp from "../../assets/landing/regua-cobranca-640.webp";

import agenda1400Avif from "../../assets/landing/agenda-confirmacoes-1400.avif";
import agenda1400Webp from "../../assets/landing/agenda-confirmacoes-1400.webp";
import agenda800Avif from "../../assets/landing/agenda-confirmacoes-800.avif";
import agenda800Webp from "../../assets/landing/agenda-confirmacoes-800.webp";

import evolucoes1600Avif from "../../assets/landing/evolucoes-1600.avif";
import evolucoes1600Webp from "../../assets/landing/evolucoes-1600.webp";
import evolucoes900Avif from "../../assets/landing/evolucoes-900.avif";
import evolucoes900Webp from "../../assets/landing/evolucoes-900.webp";

import celHoje680Avif from "../../assets/landing/celular-hoje-680.avif";
import celHoje680Webp from "../../assets/landing/celular-hoje-680.webp";
import celHoje400Avif from "../../assets/landing/celular-hoje-400.avif";
import celHoje400Webp from "../../assets/landing/celular-hoje-400.webp";

import celAgenda680Avif from "../../assets/landing/celular-agenda-680.avif";
import celAgenda680Webp from "../../assets/landing/celular-agenda-680.webp";
import celAgenda400Avif from "../../assets/landing/celular-agenda-400.avif";
import celAgenda400Webp from "../../assets/landing/celular-agenda-400.webp";

import celEvolucao680Avif from "../../assets/landing/celular-evolucao-680.avif";
import celEvolucao680Webp from "../../assets/landing/celular-evolucao-680.webp";
import celEvolucao400Avif from "../../assets/landing/celular-evolucao-400.avif";
import celEvolucao400Webp from "../../assets/landing/celular-evolucao-400.webp";

import celCobranca680Avif from "../../assets/landing/celular-cobranca-680.avif";
import celCobranca680Webp from "../../assets/landing/celular-cobranca-680.webp";
import celCobranca400Avif from "../../assets/landing/celular-cobranca-400.avif";
import celCobranca400Webp from "../../assets/landing/celular-cobranca-400.webp";

import andresa720Avif from "../../assets/landing/andresa-720.avif";
import andresa720Webp from "../../assets/landing/andresa-720.webp";
import andresa420Avif from "../../assets/landing/andresa-420.avif";
import andresa420Webp from "../../assets/landing/andresa-420.webp";

const build = (large, small, width, height) => ({
  avif: `${small.avif} ${small.w}w, ${large.avif} ${large.w}w`,
  webp: `${small.webp} ${small.w}w, ${large.webp} ${large.w}w`,
  src: large.webp,
  width,
  height,
});

export const IMAGES = {
  rotinaHoje: build(
    { avif: rotinaHoje1600Avif, webp: rotinaHoje1600Webp, w: 1600 },
    { avif: rotinaHoje900Avif, webp: rotinaHoje900Webp, w: 900 },
    1600,
    886
  ),
  regua: build(
    { avif: regua1100Avif, webp: regua1100Webp, w: 1100 },
    { avif: regua640Avif, webp: regua640Webp, w: 640 },
    1100,
    1002
  ),
  agenda: build(
    { avif: agenda1400Avif, webp: agenda1400Webp, w: 1400 },
    { avif: agenda800Avif, webp: agenda800Webp, w: 800 },
    1400,
    830
  ),
  evolucoes: build(
    { avif: evolucoes1600Avif, webp: evolucoes1600Webp, w: 1600 },
    { avif: evolucoes900Avif, webp: evolucoes900Webp, w: 900 },
    1600,
    1090
  ),
  celularHoje: build(
    { avif: celHoje680Avif, webp: celHoje680Webp, w: 680 },
    { avif: celHoje400Avif, webp: celHoje400Webp, w: 400 },
    680,
    1472
  ),
  celularAgenda: build(
    { avif: celAgenda680Avif, webp: celAgenda680Webp, w: 680 },
    { avif: celAgenda400Avif, webp: celAgenda400Webp, w: 400 },
    680,
    1472
  ),
  celularEvolucao: build(
    { avif: celEvolucao680Avif, webp: celEvolucao680Webp, w: 680 },
    { avif: celEvolucao400Avif, webp: celEvolucao400Webp, w: 400 },
    680,
    1472
  ),
  celularCobranca: build(
    { avif: celCobranca680Avif, webp: celCobranca680Webp, w: 680 },
    { avif: celCobranca400Avif, webp: celCobranca400Webp, w: 400 },
    680,
    1472
  ),
  andresa: build(
    { avif: andresa720Avif, webp: andresa720Webp, w: 720 },
    { avif: andresa420Avif, webp: andresa420Webp, w: 420 },
    720,
    1026
  ),
};
